import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import {
		nextTick,
		onMounted
	} from 'vue'

	/*eslint-disable*/
	
	const __default__ = { name: 'GoogleMapsAutoComplete' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		inputId: {
			type: String,
			default: ""
		},
		modelValue: {
			type: Object,
			default: null
		}

	},
  emits: [
		'update:modelValue'
	],
  setup(__props, { emit }) {

const props = __props;

	

	

	onMounted(() => {
		initAutocomplete()
	})

	// This sample uses the Places Autocomplete widget to:
	// 1. Help the user select a place
	// 2. Retrieve the address components associated with that place
	// 3. Populate the form fields with those address components.
	// This sample requires the Places library, Maps JavaScript API.
	// Include the libraries=places parameter when you first load the API.
	// For example: <script
	// src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">

	let autocomplete: google.maps.places.Autocomplete
	let addressSearchField: HTMLInputElement

	function initAutocomplete() {
		try{
			addressSearchField = document.getElementById(props.inputId) as HTMLInputElement
  
			// Create the autocomplete object, restricting the search predictions to
			// addresses in the US and Canada.
			autocomplete = new google.maps.places.Autocomplete(addressSearchField, {
				componentRestrictions: { country: ["us", "ca"] },
				fields: ["address_components"],
				types: ["address"]
			})
			autocomplete.setFields(['address_components'])
  
			// When the user selects an address from the drop-down, populate the
			// address fields in the form.
			autocomplete.addListener("place_changed", fillInAddress)
		}
		catch(e){
			console.log(e)
		}
	}

	async function fillInAddress() {
		// Get the place details from the autocomplete object.
		const place = autocomplete.getPlace()
		let address1 = ''
		let address2 = ''
		let city = ''
		let state = ''
		let postcode = ''

		// Get each component of the address from the place details,
		// and then fill-in the corresponding field on the form.
		// place.address_components are google.maps.GeocoderAddressComponent objects
		// which are documented at http://goo.gle/3l5i5Mr
		for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
			// @ts-ignore remove once typings fixed
			const componentType = component.types[0]

			switch (componentType) {
				case "street_number": {
					address1 = `${component.long_name} ${address1}`
					break
				}

				case "route": {
					address1 += component.short_name
					break
				}

				case "postal_code": {
					postcode = `${component.long_name}${postcode}`
					break
				}

				case "postal_code_suffix": {
					postcode = `${postcode}-${component.long_name}`
					break
				}

				case "locality": {
					city = component.long_name
					break
				}

				case "administrative_area_level_1": {
					state = component.short_name
					break
				}
			}
		}

		emit('update:modelValue',  {
			searchString: address1 + " " + address2 + " " + city + ", " + state + " " + postcode,
			address1: address1,
			address2: address2,
			city: city,
			state: state,
			zipcode: postcode
		} )
		await nextTick()
	}

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})